import { getBuyNowAlternativePayments } from '@/modules/buy-now/infrastructure/services/getBuyNowAlternativePayments.queries';
import type { CartPayments } from '@/modules/cart/domain/CartPayments';

export async function getBuyNowAlternativePaymentsById(
  cartId: string
): Promise<CartPayments> {
  const response = await getBuyNowAlternativePayments(cartId);
  return response.data;
}
